import React from 'react';
//components
import DatePicker from '@/components/DatePicker';
//styles
import styles from './Filters.module.scss';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//stores
import useSearchCampaignStore from '@/stores/SearchCampaign';
//helpers
import { matchDisabledDays } from '../../helpers';
const StartDate = () => {
    const { startDateFrom, startDateTo, setStartDateFrom, setStartDateTo } = useSearchCampaignStore((state) => ({
        startDateFrom: state.dateFilters.startDateFrom,
        startDateTo: state.dateFilters.startDateTo,
        setStartDateFrom: state.dateFilters.setStartDateFrom,
        setStartDateTo: state.dateFilters.setStartDateTo,
    }));
    const onStartDateFromChange = (date) => {
        setStartDateFrom(date);
    };
    const onStartDateToChange = (date) => {
        setStartDateTo(date);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { className: styles.filterLabel, variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Highest_Emphasis }, "Start Date"),
        React.createElement("div", { className: styles.dateFilters },
            React.createElement(DatePicker, { setValue: onStartDateFromChange, placeholder: "Start date From", value: startDateFrom, disabledDateMatcher: (date) => matchDisabledDays(date), className: styles.dateButton }),
            React.createElement(DatePicker, { setValue: onStartDateToChange, placeholder: "Start date To", value: startDateTo, disabledDateMatcher: (date) => matchDisabledDays(date, startDateFrom), className: styles.dateButton }))));
};
export default StartDate;
